import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { BranchModel } from '../model/index';
@Injectable()
export class BranchService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private branchUrl = 'api/branch';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getBranchList(query: any): Promise<BranchModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.branchUrl}/branchList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteBranch(company_id: any): Promise<BranchModel> {
       const url = `${this.branchUrl}/deleteBranch`;
       return this.http
           .post(url, $.param({ company_id: company_id }), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as BranchModel)
           .catch(this.handleError);
   }

   addUpdateBranch(branchData: any): Promise<BranchModel> {

       const url = `${this.branchUrl}/addUpdateBranch`;

       return this.http
           .post(url, $.param(branchData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as BranchModel)
           .catch(this.handleError);
   }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/branch.service.ts